<template>
    <div>
        <base-header class="pb-6 bg-light">
            <b-row align-v="center" class="py-4">
                <b-col cols="12" lg="6">
                <h6 class="h2 d-inline-block mb-0 text-dark">SIM Generator</h6>
                </b-col>
                <b-col cols="12" lg="6" class="text-right">
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-bread-crumb></route-bread-crumb>
                </nav>
                </b-col>
            </b-row>
        
            <div v-if="noAccess">
                <b-card>
                <b-card-header>
                    <p class="h2 mb-2">
                    <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
                    >&nbsp;Restricted
                    </p>
                </b-card-header>
                <b-card-body>Access is Restricted</b-card-body>
                </b-card>
            </div>
            <div v-else>
                <b-card no-body class="mb-0 border-non-radius" id="new_carrier_card">
                    <b-card-header header-tag="header" class="p-0 mb-0" role="tab">
                        <template v-if="!submitStatus"><br>
                            <p class="text-center">This tool generates SIM data for use with pSIM and eSIM. (CSV,XLS,OUT) formats.</p>
                        </template>
                        <template v-else>
                            <div class="d-flex justify-content-between w-100 mt-4">
                                <div class="ml-3 cursor-pointer" v-on:click="submitStatus=false"><i class="fa fa-angle-double-left"></i></div>
                                <h1 class="text-center">Output Page</h1>
                                <h1></h1>
                            </div>
                            <p class="text-center">Generating Test cards for <b>{{simTool.name}}</b></p>
                            <p class="text-center">Batch number is: {{batchNumber}}</p>
                            <p class="text-center">Submitted data via POST</p>
                        </template>
                    </b-card-header>
                   
                    <b-card-body v-if="!submitStatus">
                       
                        <validation-observer ref="newCarrier" v-slot="{ handleSubmit }">
                            <b-form @submit.stop.prevent="handleSubmit(sumbitTookit)">
                                <b-row class="mt-2">
                                    <b-col lg="10">
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-center">
                                                <label for="name" class="font-weight-500 mt-2">Operator Name</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="operator name"
                                                    :rules="{ required: true }"
                                                    v-slot="validationContext"
                                                    >
                                                    <b-input-group id="name" class="mb-0" >
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-address-card text-dark-50"></i>
                                                            </b-input-group-text>
                                                            </template>
                                                        <b-form-input
                                                            id="name"
                                                            name="name"
                                                            v-model="simTool.name"
                                                            aria-describedby="name"
                                                            :state="getValidationState(validationContext)"
                                                        ></b-form-input>
                                                        <b-form-invalid-feedback id="name">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="iccid" class="font-weight-500 mt-2">Start ICCID</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="start iccid"
                                                    :rules="{ required: true, regex: /^([0-9]+)$/, min: 18, max: 19 }"
                                                    v-slot="validationContext"
                                                    >
                                                    <b-input-group id="iccid" class="mb-0">
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-briefcase text-dark-50"></i>
                                                            </b-input-group-text>
                                                            </template>
                                                        <b-form-input
                                                            id="iccid"
                                                            name="iccid"
                                                            v-model="simTool.iccid"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="iccid"
                                                            >
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="iccid">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="imsi" class="font-weight-500 mt-2">Start IMSI</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="iccid"
                                                    :rules="{ required: true, regex: /^([0-9]+)$/, min: 15, max: 15 }"
                                                    v-slot="validationContext"
                                                    >
                                                    <b-input-group id="imsi" class="mb-0">
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-mobile text-dark-50"></i>
                                                            </b-input-group-text>
                                                            </template>
                                                        <b-form-input
                                                            id="imsi"
                                                            name="imsi"
                                                            v-model="simTool.imsi"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="imsi"
                                                            >
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="imsi">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="select" class="font-weight-500 mt-2">Select</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="select"
                                                    :rules="{ required: false }"
                                                    v-slot="validationContext"
                                                >
                                                    <b-form-group id="select" class="mb-0">
                                                        <b-form-select
                                                            id="select"
                                                            name="select"
                                                            v-model="simTool.select"
                                                            :options="selectOptions"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="select"
                                                            >
                                                        </b-form-select>
                                                        <b-form-invalid-feedback id="select">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="number" class="font-weight-500 mt-2">Number to be Generated</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="number"
                                                    :rules="{ required: true, regex: /^([0-9]+)$/ }"
                                                    v-slot="validationContext"
                                                >
                                                    <b-input-group id="number" class="mb-0">
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-copy text-dark-50"></i>
                                                            </b-input-group-text>
                                                            </template>
                                                        <b-form-input
                                                            id="number"
                                                            name="number"
                                                            v-model="simTool.number"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="number"
                                                            >
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="number">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="ki" class="font-weight-500 mt-2">KI</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="ki"
                                                    :rules="{ required: false }"
                                                    v-slot="validationContext"
                                                >
                                                    <b-input-group id="ki" class="mb-0">
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-gift text-dark-50"></i>
                                                            </b-input-group-text>
                                                        </template>
                                                        <b-form-input
                                                            id="ki"
                                                            name="ki"
                                                            v-model="simTool.ki"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="ki"
                                                            >
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="ki">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                    <small class="text-grey">Optional, random Ki value generated if not populated</small>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="opc" class="font-weight-500 mt-2">OPC</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="opc"
                                                    :rules="{ required: false }"
                                                    v-slot="validationContext"
                                                >
                                                    <b-input-group id="opc" class="mb-0">
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-keyboard text-dark-50"></i>
                                                            </b-input-group-text>
                                                        </template>
                                                        <b-form-input
                                                            id="opc"
                                                            name="opc"
                                                            v-model="simTool.opc"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="opc"
                                                            >
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="opc">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                    <small class="text-grey">Optional, random OPC value generated if not populated</small>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="key" class="font-weight-500 mt-2">Transport Key to use</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="key"
                                                    :rules="{ required: false }"
                                                    v-slot="validationContext"
                                                >
                                                    <b-input-group id="key" class="mb-0">
                                                        <template #prepend>
                                                            <b-input-group-text class="prepend-text-icon">
                                                                <i class="fa fa-key text-dark-50"></i>
                                                            </b-input-group-text>
                                                        </template>
                                                        <b-form-input
                                                            id="key"
                                                            name="key"
                                                            v-model="simTool.key"  
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="key"
                                                            >
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="key">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="cipher" class="font-weight-500 mt-2">Cipher</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <validation-provider
                                                    name="cipher"
                                                    :rules="{ required: false }"
                                                    v-slot="validationContext"
                                                >
                                                    <b-form-group id="cipher" class="mb-0">
                                                        <b-form-select
                                                            id="cipher"
                                                            name="cipher"
                                                            v-model="simTool.cipher"  
                                                            :options="cipherOptions"
                                                            :state="getValidationState(validationContext)"
                                                            aria-describedby="cipher"
                                                            >
                                                        </b-form-select>
                                                        <b-form-invalid-feedback id="cipher">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-form-group>
                                                </validation-provider>
                                            </b-col>
                                        </b-row>

                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                                <label for="transport" class="font-weight-500 mt-2">Apply Transport To:</label>
                                            </b-col>
                                            <b-col md="8" lg="8" >
                                                <b-form-group id="transport" class="mb-0 ml-3">
                                                    <b-form-checkbox
                                                        id="eKi"
                                                        name="eKi"
                                                        size="sm"
                                                        v-model="simTool.eKi"  
                                                        aria-describedby="eKi"
                                                        >
                                                        eKi
                                                    </b-form-checkbox>
                                                    <b-form-checkbox
                                                        id="eOPc"
                                                        name="eOPc"
                                                        size="sm"
                                                        v-model="simTool.eOPc"  
                                                        aria-describedby="eOPc"
                                                        >
                                                        eOPc
                                                    </b-form-checkbox>
                                                </b-form-group>
                                                <small class="text-grey">Keys to be obfuscated with Transport Key</small>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-2">
                                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                                            </b-col>
                                            <b-col md="8" lg="8" class="text-right">
                                                <base-button type="primary"  title="Submit" nativeType="submit" class="mt-3 mt-md-2 mr-0 " >
                                                    Submit
                                                </base-button>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col lg="2"></b-col>
                                </b-row>
                            </b-form>
                        </validation-observer>
                    </b-card-body>

                    <b-card-body v-else>

                        <b-row class="mb-4 text-center">
                            <b-col md="4" sm="12" class="mt-2 ">
                                <download-excel :data="exportData" :name="exportDataTitle">
                                    <base-button title="Download in Excel format for internal use" type="success" size="sm">
                                        Download in Excel format for internal use
                                    </base-button>
                                </download-excel>
                            </b-col>
                            <b-col md="4" sm="12" class="mt-2">
                                <vue-json-to-csv :json-data="exportData" :csv-title="exportDataTitle">
                                    <base-button title="Download in .csv format for SIM vendor" type="warning" size="sm">
                                        Download in .csv format for SIM vendor
                                    </base-button>
                                </vue-json-to-csv>
                            </b-col>
                            <b-col md="4" sm="12" class="mt-2">
                                <base-button title="Download in .out format for SIM vendor" type="primary" size="sm" v-on:click="exportAsOut">
                                    Download in .out format for SIM vendor      
                                </base-button>
                            </b-col>
                        </b-row>
                        <div class="grey-sideborder">
                            <b-table
                                striped hover
                                :items="tableData"
                                :fields="tableColumns"
                                table-class="text-nowrap"
                                head-row-variant="primary-table"
                                class="primary-table w-auto"
                                sticky-header="true"
                                show-empty
                                responsive
                                small
                            >
                            </b-table>
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </base-header>
    </div>
</template>
<script>
import initService from '../../../common/api-services/init-service';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {ValidationProvider} from 'vee-validate';
import VueJsonToCsv from 'vue-json-to-csv'
import downloadExcel from "vue-json-excel";
import bigDecimal from 'js-big-decimal';
import formatType from '../../../common/format/format-type'
export default {
    name: 'ota-sim-tool',
    components: {
        ValidationProvider,
        RouteBreadCrumb,
        VueJsonToCsv,
        downloadExcel
    },
    data() {
        return  {
            noAccess: true,
            simTool: {
                name: '',
                iccid: '',
                imsi: '',
                select: '',
                number: '',
                ki: '',
                opc: '',
                key: '',
                cipher: '',
                eKi: false,
                eOPc: false
            },
            selectOptions: [
                {value: "", text: "Select One"},
                {value: "ASTAC", text: "ASTAC"},
                {value: "Bravado Wireless", text: "Bravado Wireless"},
                {value: "Cambridge Telephone", text: "Cambridge Telephone"},
                {value: "Carolina West Wireless eSIM", text: "Carolina West Wireless eSIM"},
                {value: "Copper Valley", text: "Copper Valley"},
                {value: "Copper Valley_eSIM", text: "Copper Valley_eSIM"},
                {value: "Cordova", text: "Cordova"},
                {value: "Cross Wireless", text: "Cross Wireless"},
                {value: "CusterTel", text: "CusterTel"},
                {value: "Eagle Telephone", text: "Eagle Telephone"},
                {value: "Execulink", text: "Execulink"},
                {value: "Inland Cellular", text: "Inland Cellular"},
                {value: "Inland Cellular eSIM", text: "Inland Cellular eSIM"},
                {value: "MNShub LLC", text: "MNShub LLC"},
                {value: "Nemont", text: "Nemont"},
                {value: "NNTC", text: "NNTC"},
                {value: "OTZ", text: "OTZ"},
                {value: "OptimERA", text: "OptimERA"},
                {value: "STRATA", text: "STRATA"},
                {value: "Silverstar", text: "Silverstar"},
                {value: "Strata_eSIM", text: "Strata_eSIM"},
                {value: "telAlaska", text: "telAlaska"},
                {value: "Standing_Rock", text: "Standing_Rock"},
            ],
            cipherOptions: [
                {value: '', text: 'None'},
                {value: 'aes128', text: 'Aes-128'},
                {value: "aes256", text: "Aes-256"},
                {value: "md5", text: "Md5"},
            ],
            submitStatus: false,
            batchNumber: 0,
            tableData: [],
            tableColumns: [
                {key: 'no', label: '#'},
                {key: 'iccid', label: 'ICCID'},
                {key: 'pin1', label: 'Pin1'},
                {key: 'pin2', label: 'Pin2'},
                {key: 'puk1', label: 'Puk1'},
                {key: 'puk2', label: 'Puk2'},
                {key: 'kic', label: 'Kic'},
                {key: 'kid', label: 'Kid'},
                {key: 'dek', label: 'Dek'},
                {key: 'operator', label: 'Operator'},
                {key: 'imsi', label: 'IMSI'},
                {key: 'ki', label: 'Ki'},
                {key: 'opc', label: 'OPc'},
                {key: 'psk16', label: 'PSK16'},
                {key: 'psk', label: 'PSK'},
                {key: 'des', label: 'DES'},
                {key: 'imsi', label: 'IMSI'},
                {key: 'adm1', label: 'ADM1'},
                {key: 'key', label: 'Transport Key'},
                {key: 'acc', label: 'ACC'},
                {key: 'eKi', label: 'eKi'},
                {key: 'eOPc', label: 'eOPc'}
            ],
            exportData: [],
            excelHeader: {
                "#base#": "iccid",
                "#luhn": "iccid"
            },
            exportDataTitle: ''
        }
    },
    mounted() {
        document.title = "OTA - Sim Tool";

        //The user needs to be notified that this is not accessible unless portal admin
        this.noAccess = !initService.getPortalAdminRole();
    },
    methods: {
        getValidationState({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},

        sumbitTookit() {
            this.tableData = [];
            this.submitStatus = true;
            this.batchNumber = this.generateBatchNumber();
            this.exportDataTitle = this.simTool.name + '_[' + this.simTool.select + ']' + this.batchNumber;
            for (let i = 0; i < this.simTool.number; i++) {
                let iccid = new bigDecimal(this.simTool.iccid).getValue() + i;
                let child = {
                    no: i + 1,
                    iccid: (iccid).toString() + this.generateLuhn(iccid),
                    pin1: this.generatePin(4),
                    pin2: this.generatePin(4),
                    puk1: this.generatePin(8),
                    puk2: this.generatePin(8),
                    kic: this.generateKey(),
                    kid: this.generateKey(),
                    dek: this.generateKey(),
                    operator: this.simTool.name,
                    imsi: Number(this.simTool.imsi) + i,
                    ki: this.simTool.ki?this.simTool.ki:this.generateKey(),
                    opc: this.simTool.opc?this.simTool.opc:this.generateKey(),
                    psk16: this.generateKey(),
                    psk: this.generateKey() + this.generateKey(),
                    des: this.generateKey(),
                    imsi: Number(this.simTool.imsi) + i,
                    adm1: this.generatePin(8),
                    key: this.simTool.key,
                    acc: '0080',
                    eKi: this.simTool.eKi?this.generateKey(): '',
                    eOPc: this.simTool.eOPc?this.generateKey(): ''
                };
                this.tableData.push(child);
            }
            this.getExportData();
        },

        getExportData() {
            this.tableData.map(item => {
                let child = {
                   '#base#': item.iccid.slice(0, item.iccid.length-1),
                    '#luhn#': item.iccid.slice(-1),
                    '#iccid#': item.iccid,
                    '#Dpin1#': item.pin1.padStart(4, '0'),
                    '#Dpin2#': item.pin2.padStart(4, '0'),
                    '#Dpuk1#': item.puk1,
                    '#Dpuk2#': item.puk2,
                    '#KIC#': item.kic,
                    '#KID#': item.kid,
                    '#DEK#': item.dek,
                    '#Operator1#': item.operator,
                    '#imsi#1': item.imsi,
                    '#OPc#': item.opc,
                    '#Ki#': item.ki,
                    '#TRANSPORT_KEY#': item.key,
                    '#PSK16#': item.psk16,
                    '#PSK#': item.psk,
                    '#DES#': item.des,
                    "#DADM1#": item.adm1,
                    '#acc#': item.acc
                }
                this.exportData.push(child)
            })
        },

        exportAsOut() {
			formatType.jsonToText(this.exportData, this.exportDataTitle + ".out");
		},

        generateBatchNumber() {
            return Math.floor(Math.random() * 900000 + 100000)
        },

        generatePin(length) {
            let result = '';
            for (let i = 0; i < length; i++) {
                result += (Math.floor(Math.random()*10)).toString()
            };
            return  result.padStart(length, '0')
        },

        generateKey(length = 32) {
            let character = '0123456789ABCDEF';
            let characterLength = character.length;
            let randomString = '';
            for (let i = 0; i < length; i++) {
                randomString += character[Math.floor(Math.random() * characterLength)]
            }
            return randomString;
        },

        generateLuhn(value) {
            let length = value.length;
            let parity = length % 2;
            let sum = 0;
            for (let i = length - 1; i >= 0; --i) {
                let char = value[i];
                if (i % 2 != parity) {
                    char *= 2;
                    if (char > 9) {
                        char -= 9;
                    }
                }
                sum += char;
            }
            return (sum * 9)%10;
        },

        applyTransport(key, cipher) {

        }
    }
}
</script>
